import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

// Style
import styles from './styles.scss';

import QuickViewIcon from 'dibs-icons/exports/InfoCircle';

type QuickViewButtonProps = {
    openQuickView?: () => void;
    showQuickViewIcon?: boolean;
    hideDivider?: boolean;
    isSbTile?: boolean;
};

export const QuickViewButton: FunctionComponent<QuickViewButtonProps> = ({
    openQuickView,
    showQuickViewIcon,
    hideDivider,
    isSbTile,
}) => {
    if (!showQuickViewIcon) {
        return null;
    }
    return (
        <a
            data-tn="quick-view-button"
            className={classnames(styles.link, {
                [styles.hideDivider]: hideDivider,
                [styles.isSbTile]: isSbTile,
            })}
            onClick={openQuickView}
        >
            <QuickViewIcon className={classnames({ [styles.isSbTile]: isSbTile })} />
        </a>
    );
};

// ignore default prop functions from coverage stats
/* istanbul ignore next */
QuickViewButton.defaultProps = {
    openQuickView: () => {},
    showQuickViewIcon: true,
};
